import { ChakraFlex, Text } from '@equip.health/ui';

const MessagesMenuHeader = () => (
  <ChakraFlex mt="16px" mx="10px">
    <Text variant="h5">Messages</Text>
  </ChakraFlex>
);

export default MessagesMenuHeader;
